module.exports = __webpack_public_path__ + "static/img/agility.fc3d4415.svg";